import React from 'react';

export default function LokasiJepang() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Lokasi Jepang</h1>
      <p className="text-gray-500">Halaman Lokasi Jepang</p>
    </div>
  );
}
